import classNames from 'classnames';
import React, { forwardRef } from 'react';
import { BaseLink } from './BaseLink.js';

const IconLink = forwardRef(({ className, href, icon, ...restProps }, ref) => {
    const iconOnlyClassName = classNames("tds-btn--icononly", className);
    return (React.createElement(BaseLink, { href: href, label: icon, className: iconOnlyClassName, ref: ref, ...restProps }));
});
IconLink.displayName = "IconLink";

export { IconLink };
//# sourceMappingURL=IconLink.js.map
